var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status !== null)?_c('Chip',_vm._b({staticClass:"status-chip",attrs:{"pill":"","small":""}},'Chip',_vm.chipProps,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }